const verifyUniqueSlug = (slug, uniqueSlugs) => {
  if (uniqueSlugs.has(slug)) {
    return false;
  }
  return true;
};

const appendCounterSlug = (slug, acc) => {
  return `${slug}-${acc}`;
};

export const getPathsWithoutCollision = (list) => {
  const newList = [];
  const uniqueSlugs = new Set();

  list.forEach((item) => {
    let counter = 1;
    if (!verifyUniqueSlug(item.Slug, uniqueSlugs)) {
      while (!verifyUniqueSlug(appendCounterSlug(item.Slug, counter), uniqueSlugs)) {
        counter++;
      }
      uniqueSlugs.add(appendCounterSlug(item.Slug, counter));
      newList.push({
        site: item.Site,
        slug: appendCounterSlug(item.Slug, counter),
      });
    } else {
      uniqueSlugs.add(item.Slug);
      newList.push({
        site: item.Site,
        slug: item.Slug,
      });
    }
  });

  return newList;
};

export const transformArticles = (articles) => {
  const uniqueSlugs = new Set();
  const newList = [];
  articles.forEach((item) => {
    let counter = 1;
    if (!verifyUniqueSlug(item.Slug, uniqueSlugs)) {
      while (!verifyUniqueSlug(appendCounterSlug(item.Slug, counter), uniqueSlugs)) {
        counter++;
      }
      uniqueSlugs.add(appendCounterSlug(item.Slug, counter));
      item.Slug = appendCounterSlug(item.Slug, counter);
      newList.push(item);
    } else {
      uniqueSlugs.add(item.Slug);
      newList.push(item);
    }
  });
  return newList;
};

export const appendSlashStart = (slug) => {
  if (slug.charAt(0) !== "/") {
    return `/${slug}`;
  }
  return slug;
};
